import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Listen from "@/pages/Listen";
import Login from "@/pages/Login";
import Studio from "@/pages/Studio";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Listen />} />
            <Route path="/login" element={<Login />} />
            <Route path="/studio" element={<Studio />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#18181B", border: "1px solid rgba(255,255,255,0.08)", color: "#fafafa" } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
